function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { crudAreas } from '@/mixins/crud_userprofile_areas.js';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import utils from '@/js/utils';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import AnalyticService from '@/apps/analytic-services/services/analytic_service.js';
import tasks from '@/js/tasks';
export default {
  name: 'AreaPage',
  //mixins: [crudAreas],
  components: {
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  data: function data() {
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      mlops_projects: [],
      mlops_projects_to_filters: [],
      mode: '',
      record: {
        "cloud_storage": {},
        "service_accounts": {}
      },
      record_original: {
        "cloud_storage": {},
        "service_accounts": {}
      },
      select_profile_areas: [],
      areas_to_filters: [],
      dialogFlag: false,
      modalId: 'dp_area',
      collapse_filter: false,
      menu: false,
      menu2: false,
      dates: [],
      filters: {
        fechas: []
      },
      alert: false,
      countDown: {
        timer: '3',
        show: false
      },
      filter_enabled: true
    }, "filters", {}), "pagination", {
      current: 1,
      limit: 10,
      total: 0,
      offset: 0
    }), "project_reference", null), "labels", []), "recipients", []), "recipient_aux", null), "headers_archivos", [{
      value: "archivo",
      text: "Archivo"
    }, {
      value: "name",
      text: "Nombre"
    }, {
      value: "actions",
      text: "Acciones"
    }]), "archivos", []), "key_archivos", 1);
  },
  computed: {
    /* ...mapState('data-platform', ['select_profile_areas']),*/headers: function headers() {
      return [{
        value: 'name',
        text: "Nombre (ID)",
        sortable: true,
        class: 'text-left',
        align: 'left'
      }, {
        value: 'business',
        text: "Business Abrev.",
        sortable: true,
        class: 'text-left',
        align: 'left'
      }, {
        value: 'environment',
        text: "Entorno",
        sortable: true,
        class: 'text-center',
        align: 'center'
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        class: 'text-center',
        align: 'center'
      }];
    },
    filtros: function filtros() {
      return {
        name: this.traductor('tabla_solicitudes.name'),
        type: this.traductor('tabla_solicitudes.type'),
        status: this.traductor('tabla_solicitudes.status'),
        rango: this.traductor('filtros.rango')
      };
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    dateRangeText: function dateRangeText() {
      return this.filters.fechas ? this.filters.fechas.join(' ~ ') : '';
    },
    modalName: function modalName() {
      return "Proyecto";
    },
    rows: function rows() {
      return this.select_profile_areas.length;
    },
    modalTitle: function modalTitle() {
      var mode = this.mode.charAt(0).toUpperCase() + this.mode.slice(1);
      var modalName = this.modalName;
      var aux = "crud." + mode;
      var modename = this.traductor(aux);
      return "".concat(modename, " ").concat(modalName);
    },
    readonly: function readonly() {
      return this.mode === 'view';
    },
    headers_label: function headers_label() {
      return [{
        text: "Label",
        value: 'label'
      }, {
        text: "Valor",
        value: 'value'
      }, {
        value: 'actions',
        sortable: false
      }];
    },
    getUserEmail: function getUserEmail() {
      return window.userInfo.email;
    }
  },
  created: function created() {
    this.get_projects();
  },
  methods: {
    preventSpaces: function preventSpaces(event) {
      if (event.key === ' ') {
        event.preventDefault();
      }
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    deletefunc: function deletefunc(row) {
      console.log(row);
      this.recipients.splice(row, 1);
    },
    addRow: function addRow() {
      this.recipients.push(this.recipient_aux);
      this.recipient_aux = null;
    },
    onDelete: function onDelete(record) {
      this.record = record;
      this.$refs['dialogConfirmation'].onOpen();
      // this.processing = false
      // this.busy = true
    },
    get_projects: function get_projects() {
      var _this = this;
      var params2 = {
        domain: window.userInfo.domain
      };
      AnalyticService.get_projects(params2).then(function (response) {
        _this.mlops_projects = response.data;
        _this.mlops_projects_to_filters = Object.assign([], response.data);
      });
    },
    onConfirmDelete: function onConfirmDelete(event) {
      var _this2 = this;
      if (!event) {
        this.$refs['dialogConfirmation'].onClose();
        return;
      }
      console.log(this.record);
      var params = {
        domain: window.userInfo.domain,
        id: this.record.id
      };
      AnalyticService.delete_project(params).then(function (datos) {
        console.log(datos);
        _this2.$refs['dialogConfirmation'].onClose();
        tasks.toast.success('Eliminado correctamente');
        _this2.get_projects();
      }, function (err) {
        _this2.$refs['dialogConfirmation'].onClose();
        tasks.toast.success(datos.message ? datos.message : 'An error occurred, please try again!');
        // this.busy = this.processing = false
      });
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.mode == 'create') {
        var labelsObj = {};
        this.labels.forEach(function (item) {
          labelsObj[item.label] = item.value;
        });
        this.record.labels = labelsObj;
        this.record.recipients = this.recipients;
        this.record.archivos = this.archivos;
        this.record.name = this.record.name.trim();
        this.record.business = this.record.business.trim();
        console.log("para backend", this.record);
        var params = {
          domain: window.userInfo.domain,
          project: this.record
        };
        AnalyticService.create_project(params).then(function (response) {
          console.log(response);
          if (response.success) {
            tasks.toast.success("Creado correctamente.");
            _this3.$refs.dialog.onClose();
            _this3.get_projects();
          } else {
            tasks.toast.error(response.message);
          }
        });
      } else if (this.mode == 'edit') {
        var _labelsObj = {};
        this.labels.forEach(function (item) {
          _labelsObj[item.label] = item.value;
        });
        this.record.labels = _labelsObj;
        this.record.recipients = this.recipients;
        this.record.name = this.record.name.trim();
        this.record.business = this.record.business.trim();
        var _params = {
          domain: window.userInfo.domain,
          project: this.record
        };
        console.log("edicion", _params);
        AnalyticService.update_project(_params).then(function (response) {
          console.log(response);
          if (response.success) {
            tasks.toast.success("Editado correctamente.");
            _this3.$refs.dialog.onClose();
            _this3.get_projects();
          } else {
            tasks.toast.error(response.message);
          }
        });
      }
    },
    addItem_label: function addItem_label() {
      this.labels.push({});
    },
    removeItem_label: function removeItem_label(data) {
      var record_details = [];
      var index = 0;
      var _iterator = _createForOfIteratorHelper(this.labels),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var detail = _step.value;
          if (data.index !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.labels = record_details;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    showModal: function showModal(data, mode) {
      if (data) {
        this.record = utils.cloneJSON(data.item);
        var arrayParaTabla = Object.entries(this.record.labels).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            label = _ref3[0],
            value = _ref3[1];
          return {
            label: label,
            value: value
          };
        });
        this.labels = arrayParaTabla;
        this.recipients = this.record.recipients;
        this.archivos = this.record.archivos;
        this.record_original = utils.cloneJSON(data.item);
      } else {
        console.log("en vacio");
        this.labels = [];
        this.recipients = [];
        this.archivos = [];
        this.record = {
          "labels": {}
        };
      }
      this.mode = mode;
      this.$refs.dialog.onOpen();
      // this.$root.$emit('bv::show::modal', this.modalId, '#btnShow')
    },
    onSearch: function onSearch() {
      var _this4 = this;
      this.mlops_projects = Object.assign([], this.mlops_projects_to_filters);
      if (this.filters.name) {
        this.mlops_projects = this.mlops_projects.filter(function (x) {
          return x.name.toUpperCase().indexOf(_this4.filters.name.toUpperCase()) != -1;
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.resetFilters();
      this.get_projects();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
    },
    addItem_archivo: function addItem_archivo() {
      this.archivos.push({});
    },
    removeItem_archivo: function removeItem_archivo(data) {
      var record_details = [];
      var index = 0;
      var _iterator2 = _createForOfIteratorHelper(this.archivos),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var detail = _step2.value;
          if (data.index !== index) {
            record_details.push(detail);
          } else {}
          index += 1;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.archivos = record_details;
    },
    getarchivo: function getarchivo(event, index) {
      console.log(event);
      this.archivos[index].archivo = event;
      this.archivos[index].name = event.name;
      this.key_archivos += 1;
      if (event) {
        this.readFile(event, index);
      }
    },
    readFile: function readFile(file, index) {
      var _this5 = this;
      var reader = new FileReader();
      reader.onload = function () {
        _this5.archivos[index].base64 = reader.result;
        console.log(_this5.archivos[index].base64);
      };
      reader.readAsDataURL(file);
    },
    downloadFile: function downloadFile(route, name) {
      var params = {
        route: route
      };
      AnalyticService.download_file(params).then(function (response) {
        console.log(response);
        var archivoContenido = response;
        var blob = new Blob([archivoContenido], {
          type: 'application/octet-stream'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    }
  }
};